import { URL_LABEL } from "../../../../../content/index.content";

const keywordToolsForAmazon = ({ language, isSavedUser }) => {
  return {
    title: "Keyword Tracker for Amazon",
    subtitle:
      "Set up tracking of listing keywords and control how optimization impacts your ranking and sales",
    href: isSavedUser
      ? `/app/#/keyword-tracker/?${URL_LABEL}`
      : `/keyword-tracker/?${URL_LABEL}`,
    isLink: !isSavedUser,
    isBlank: isSavedUser,
  };
};

export default keywordToolsForAmazon;
